module.exports = __webpack_public_path__ + "static/img/010.a7f024b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/datav-gejiachecun/010.png
// module id = KfbJ
// module chunks = 1